/** Guest lists read like a roll call: A→Z by first name, last name as tiebreak. */
export interface GuestName {
  first_name?: string | null;
  last_name?: string | null;
}

const trimmed = (v: string | null | undefined) => (v ?? "").trim();

const hasName = (n: GuestName | null | undefined) =>
  !!(trimmed(n?.first_name) || trimmed(n?.last_name));

/**
 * Case- and accent-insensitive A→Z on first name, then last name.
 * Guests with no name at all sink to the bottom instead of heading the list.
 */
export const compareGuestNames = (
  a: GuestName | null | undefined,
  b: GuestName | null | undefined,
): number => {
  if (!hasName(a) || !hasName(b)) return hasName(a) ? -1 : hasName(b) ? 1 : 0;
  const byFirst = trimmed(a?.first_name).localeCompare(trimmed(b?.first_name), undefined, {
    sensitivity: "base",
  });
  if (byFirst !== 0) return byFirst;
  return trimmed(a?.last_name).localeCompare(trimmed(b?.last_name), undefined, {
    sensitivity: "base",
  });
};
